import React from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetAddonsCommissionsReport } from '../../../api/services/finance'
import { DatePicker } from '../../shared/DatePicker'
import { Form } from 'semantic-ui-react'
import { useTextResources } from '../../../language'
import moment from 'moment'
import { endpoint } from '../../../api/http'
import { dateFormat } from '../../shared/constants'

const AddonsCommissionsReport = ()=>{
    const text = useTextResources()
    const formatter = ({value})=>{
        return value&&value.toFixed(2)
    }
    
    const dateFormatter = ({value})=>{
        return value&&moment(value).format(dateFormat)
    }

    
    const reservationFormatter = ({value, row})=>{
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>{value}</a>
    }
     

    const gridOptions = {
        search: {
            title: "Addons Channel Commissions Report",
            description: "Addon commissions by channel",
            fields: [ 
                <DatePicker 
                    type="basic"
                    label= {text("StartDate")} 
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker 
                    type="basic"
                    label= {text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />,
                <Form.Field control={HotelsDropDown} width="4" multiple label= {text("Hotel")} key="HotelIDs"/>
            ],
            api: GetAddonsCommissionsReport
        },
        grid: {
            columns: [
                { name: 'HotelName', title: 'Hotel' },
                { name: 'ReservationNumber', title: 'Reservation', formatter: reservationFormatter },
                { name: 'Status', title: 'Status' },
                { name: 'Nationality', title: 'Nationality' },
                { name: 'CheckInDate', title: 'Check In Date', formatter: dateFormatter },
                { name: 'CheckOutDate', title: 'Check Out Date', formatter: dateFormatter },
                { name: 'SumChannelCommision', title: 'Channel Commision', formatter },
                { name: 'AgentName', title: 'Agent' },
                { name: 'CompanyName', title: 'Company' },
                { name: 'Currency', title: 'Currency' }
            ],
            pdf: true,
            export: true,
            summary: true, 
            totalSummaryItems: [
                { columnName: 'SumChannelCommision', type: 'sum' }
            ]
        }
    }
    return (<GridSearchTemplate options={gridOptions}/>)
}

export default AddonsCommissionsReport